/** Caminhos atuais da documentação Microsoft Learn (2024+). */
const DOC_PATHS = {
  smtpAuth: "/exchange/clients-and-mobile-in-exchange-online/authenticated-client-smtp-submission",
  imapPop: "/troubleshoot/exchange/user-and-shared-mailboxes/pop3-imap-owa-activesync-office-365",
  emailApps:
    "/exchange/recipients-in-exchange-online/manage-user-mailboxes/managing-email-apps-for-user-mailboxes",
  basicAuth: "/exchange/clients-and-mobile-in-exchange-online/deprecation-of-basic-authentication-exchange-online",
  mailFlowSetup:
    "/exchange/mail-flow-best-practices/how-to-set-up-a-multifunction-device-or-application-to-send-email-using-microsoft-365-or-office-365",
  imapAccessAsApp:
    "/exchange/client-developer/legacy-protocols/how-to-authenticate-an-imap-pop-smtp-application-by-using-oauth",
  appPermissions: "/graph/auth-v2-service",
};

const APP_PASSWORD_PATH =
  "/account-billing/using-app-passwords-with-apps-that-don-t-support-two-step-verification-5896ed9b-4263-e681-128a-a6f2979a7944";

function resolveLearnLocale(language) {
  const lang = String(language || "pt-BR").toLowerCase();
  if (lang.startsWith("pt")) return "pt-br";
  if (lang.startsWith("es")) return "es-es";
  if (lang.startsWith("it")) return "it-it";
  return "en-us";
}

function resolveSupportLocale(language) {
  const lang = String(language || "pt-BR").toLowerCase();
  if (lang.startsWith("pt")) return "pt-br";
  if (lang.startsWith("es")) return "es-es";
  if (lang.startsWith("it")) return "it-it";
  return "en-us";
}

export function getOffice365DocLinks(language) {
  const learnLocale = resolveLearnLocale(language);
  const supportLocale = resolveSupportLocale(language);
  const learnBase = `https://learn.microsoft.com/${learnLocale}`;

  return {
    smtpAuth: `${learnBase}${DOC_PATHS.smtpAuth}`,
    imapPop: `${learnBase}${DOC_PATHS.imapPop}`,
    emailApps: `${learnBase}${DOC_PATHS.emailApps}`,
    appPassword: `https://support.microsoft.com/${supportLocale}${APP_PASSWORD_PATH}`,
    basicAuth: `${learnBase}${DOC_PATHS.basicAuth}`,
    outlookWeb: "https://outlook.office365.com",
    imapAccessAsApp: `https://learn.microsoft.com/en-us${DOC_PATHS.imapAccessAsApp}`,
    appPermissions: `https://learn.microsoft.com/en-us${DOC_PATHS.appPermissions}`,
  };
}

export const OFFICE365_DOC_LINK_KEYS = [
  "smtpAuth",
  "imapPop",
  "emailApps",
  "appPassword",
  "basicAuth",
  "outlookWeb",
];

export { DOC_PATHS };
